import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import { useState } from "react";
import { Toast } from "../../components/ToastComponent";

const ListStockImportExcel = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [selectedFile, setSelectedFile] = useState(null);

  const downloadExcelTemplate = async () => {
    try {
      const response = await fetch(
        `${API_URL}/stock/import-template-download`,
        {
          method: "GET",
          headers: {
            // 'Authorization': `Bearer ${yourToken}`
          },
        }
      );

      if (!response.ok) throw new Error("Failed to download");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "stock_import.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/warehouse",
    defaultQuery: "status=ACTIVE",
  });

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedFile) {
      //alert("Please select a file to upload.");
      Toast.fire({
        icon: "warning",
        title: "Please select a file to upload",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await fetch(`${API_URL}/stock/import-upload`, {
        method: "POST",
        body: formData,
        // headers should NOT include Content-Type when using FormData
      });

      if (!response.ok) throw new Error("Upload failed");
      //alert("File uploaded successfully!");
      Toast.fire({
        icon: "success",
        title: "Stock Successfully Imported",
      });

      setSelectedFile(null);
      reload(); // if needed to refresh table
    } catch (error) {
      console.error("Upload error:", error);
      //alert("Failed to upload file.");
      Toast.fire({
        icon: "error",
        title: "Failed to upload file",
      });
    }
  };
  return (
    <>
      <div className="page-layout">
        <div className="page-header">
          <h1>Stock Import Excel</h1>
        </div>
        <div className="table-container">
          <div>
            <button
              onClick={downloadExcelTemplate}
              className="  px-4 py-3 rounded bg-red-500 "
            >
              <div className="flex  gap-3">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.4126 17.2325V1H10.102C6.73567 1.60819 3.37848 2.17076 0 2.75462V18.1083C3.32374 18.6952 6.69006 19.2821 10.0351 19.8903H11.4035V17.2325H11.4126ZM6.46198 13.8632C6.04269 12.9666 5.67515 12.0467 5.36117 11.1081C5.05707 11.9991 4.63742 12.8384 4.2938 13.7111C3.81333 13.7111 3.33286 13.6837 2.8524 13.6655C3.41497 12.5616 3.9593 11.4486 4.54011 10.3539C4.04748 9.22268 3.50316 8.11579 2.99532 6.99368L4.44889 6.91158C4.77427 7.76912 5.1331 8.61754 5.40374 9.49637C5.70783 8.5628 6.12444 7.67181 6.49544 6.78386C6.99212 6.74939 7.48982 6.71898 7.98853 6.69263C7.40467 7.89278 6.81575 9.09598 6.22175 10.3022C6.82994 11.5186 7.43813 12.7502 8.04631 13.9787C7.51719 13.9361 6.99111 13.9027 6.46198 13.8632Z"
                    fill="white"
                  />
                  <path
                    d="M11.9658 3.10352V4.26819H14.2921V5.98632H11.9658V6.92901H14.2921V8.64714H11.9658V9.58983H14.2921V11.3049H11.9658V12.2476H14.2921V13.9505H11.9658V14.948H14.2921V16.6113H11.9658V17.776H20V3.10352H11.9658ZM18.2271 16.6235H14.8456V14.9601H18.2271V16.6235ZM18.2271 13.9627H14.8456V12.2446H18.2271V13.9627ZM18.2271 11.3019H14.8456V9.58679H18.2271V11.3019ZM18.2271 8.64106H14.8456V6.92597H18.2271V8.64106ZM18.2271 5.98024H14.8456V4.26819H18.2271V5.98024Z"
                    fill="white"
                  />
                </svg>
                <p className="text-white">Stock Template Excel</p>
              </div>
            </button>
          </div>

          <div className="flex items-center ">
            <div className=" w-full max-w-[550px] bg-white">
              <form className="py-6 px-9" method="POST" onSubmit={handleSubmit}>
                <div className="mb-6 pt-4">
                  <label className="mb-5 block text-xl font-semibold text-[#07074D]">
                    Upload File
                  </label>

                  <div className="mb-8">
                    <input
                      type="file"
                      name="file"
                      id="file"
                      className="sr-only"
                      onChange={handleFileChange}
                    />
                    <label
                      for="file"
                      className="relative flex min-h-[200px] items-center justify-center rounded-md border border-dashed border-[#e0e0e0] p-12 text-center"
                    >
                      <div>
                        <span className="mb-2 block text-xl font-semibold text-[#07074D]">
                          {selectedFile ? selectedFile.name : "Drop files here"}
                        </span>
                        <span className="mb-2 block text-base font-medium text-[#6B7280]">
                          Or
                        </span>
                        <span className="inline-flex rounded border border-[#e0e0e0] py-2 px-7 text-base font-medium text-[#07074D]">
                          Browse
                        </span>
                      </div>
                    </label>
                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    className="hover:shadow-form w-full rounded-md bg-[#6A64F1] py-3 px-8 text-center text-base font-semibold text-white outline-none"
                  >
                    Send File
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>

    // <TableLayout
    //   title="Stock Import List"
    //   data={data}
    //   headers={headers}
    //   detailPopupHeaders={detailPopupHeaders}
    //   detailPopupTitle="Warehouse Information"
    //   idKey="warehouse_id"
    //   endPoint="/warehouse"
    //   setCurrentPage={setCurrentPage}
    //   hasDetails
    //   hasSearch
    //   hasCreate
    //   hasActions
    //   module="Warehouse"
    //   subModule="Stock Import"
    //   createPath={`/warehouse/list/create`}
    //   currentPath={currentPath}
    //   onSearch={(value) => handleSearch(value)}
    //   disabledSerial
    //   reload={reload}
    //   customButtons={
    //     <button
    //       onClick={downloadExcelTemplate}
    //       className="  px-4 py-3 rounded bg-red-500 "
    //     >
    //       <div className="flex  gap-3">
    //         <svg
    //           width="20"
    //           height="20"
    //           viewBox="0 0 20 20"
    //           fill="none"
    //           xmlns="http://www.w3.org/2000/svg"
    //         >
    //           <path
    //             d="M11.4126 17.2325V1H10.102C6.73567 1.60819 3.37848 2.17076 0 2.75462V18.1083C3.32374 18.6952 6.69006 19.2821 10.0351 19.8903H11.4035V17.2325H11.4126ZM6.46198 13.8632C6.04269 12.9666 5.67515 12.0467 5.36117 11.1081C5.05707 11.9991 4.63742 12.8384 4.2938 13.7111C3.81333 13.7111 3.33286 13.6837 2.8524 13.6655C3.41497 12.5616 3.9593 11.4486 4.54011 10.3539C4.04748 9.22268 3.50316 8.11579 2.99532 6.99368L4.44889 6.91158C4.77427 7.76912 5.1331 8.61754 5.40374 9.49637C5.70783 8.5628 6.12444 7.67181 6.49544 6.78386C6.99212 6.74939 7.48982 6.71898 7.98853 6.69263C7.40467 7.89278 6.81575 9.09598 6.22175 10.3022C6.82994 11.5186 7.43813 12.7502 8.04631 13.9787C7.51719 13.9361 6.99111 13.9027 6.46198 13.8632Z"
    //             fill="white"
    //           />
    //           <path
    //             d="M11.9658 3.10352V4.26819H14.2921V5.98632H11.9658V6.92901H14.2921V8.64714H11.9658V9.58983H14.2921V11.3049H11.9658V12.2476H14.2921V13.9505H11.9658V14.948H14.2921V16.6113H11.9658V17.776H20V3.10352H11.9658ZM18.2271 16.6235H14.8456V14.9601H18.2271V16.6235ZM18.2271 13.9627H14.8456V12.2446H18.2271V13.9627ZM18.2271 11.3019H14.8456V9.58679H18.2271V11.3019ZM18.2271 8.64106H14.8456V6.92597H18.2271V8.64106ZM18.2271 5.98024H14.8456V4.26819H18.2271V5.98024Z"
    //             fill="white"
    //           />
    //         </svg>
    //         <p className="text-white"> Export Excel</p>
    //       </div>
    //     </button>
    //   }
    // />
  );
};

export default ListStockImportExcel;
